<template>
  <v-container fluid>
    <PageTitle icon="fal fa-fw fa-fax">
      Fax Contacts
      <template v-slot:buttons>
        <v-btn :to="{name: `${$root.routePrefix}.send_fax`}"
               color="primary"
               class="mr-2">
          Send fax
        </v-btn>
        <v-btn :to="{name: `${$root.routePrefix}.fax_messages.index`}"
               class="mr-2"
               exact>
          Fax Messages
        </v-btn>
        <v-btn :to="{name: `${$root.routePrefix}.fax_contact.create`}"
               class="mr-2">
          New Contact
        </v-btn>
        <v-btn v-if="team.id === 280"
               @click.prevent="synchronize"
               class="mr-2">
          Synchronize
        </v-btn>
        <v-btn @click.prevent="fetchData">
          Refresh
        </v-btn>
      </template>
    </PageTitle>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-text-field v-model="search"
                          prepend-inner-icon="fal fa-search"
                          label="Search"
                          outlined
                          dense
                          hide-details>
            </v-text-field>
          </v-card-text>
          <fax-contacts-paginated-table :loading="loading"
                                        :contacts="contacts"
                                        :search="search">
          </fax-contacts-paginated-table>
        </v-card>
      </v-col>
      <v-col v-if="1===2"
             cols="12"
             md="3">
        <create-fax-contact-form class="mb-4"
                                 @updated="fetchData">
        </create-fax-contact-form>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import faxService from '../../../services/faxService';
import FaxMessagesPaginatedTable from './components/FaxMessagesPaginatedTable';
import echo from '../../../plugins/echo';
import CreateFaxContact from './CreateFaxContact';
import FaxContactsPaginatedTable from './components/FaxContactsPaginatedTable';
import CreateFaxContactForm from './components/CreateFaxContactForm';
import {orderBy} from 'lodash';
import PageTitle from '../../../components/PageTitle.vue';

export default {
  components: {PageTitle, CreateFaxContactForm, FaxContactsPaginatedTable, CreateFaxContact, FaxMessagesPaginatedTable},
  data() {
    return {
      loading: false,
      contacts: [],
      search: '',
    }
  },
  computed: {
    ...mapGetters([
      'isMember',
      'team',
      'user',
    ]),
  },
  created() {
    //this.initEcho();
    this.fetchData();
  },
  methods: {
    initEcho() {
      echo.private(this.team.channel)
        .listen('Fax.FaxMessageEventProcessed', e => {
          console.log('FaxMessageEventProcessed', e);
          this.fetchData();
        })
    },
    fetchData() {
      this.loading = true;
      faxService.getContacts()
        .then(data => {
          this.contacts = orderBy(data, ['company_name', 'slug', 'fax_number'], ['asc', 'asc', 'asc']);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    async synchronize() { // MLD-6662
      await faxService.synchronizeContacts();
      this.$toast.success('Synchronizing fax contacts from CRM. Click refresh in 10-15 seconds.');
    }
  }
}
</script>
